import { useState } from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

const inputStyle = {
  width: '100%',
  padding: '10px 14px',
  backgroundColor: theme.colors.background,
  border: `1px solid ${theme.colors.border}`,
  borderRadius: '7px',
  color: theme.colors.text,
  fontSize: '1rem',
  boxSizing: 'border-box',
  outline: 'none',
};

const labelStyle = {
  display: 'block',
  color: theme.colors.textMuted,
  marginBottom: '0.4rem',
  fontSize: '0.9rem',
};

function ForgotPassword() {
  const isMobile = useIsMobile();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.message || 'Error al procesar la solicitud');
        return;
      }
      setSent(true);
    } catch {
      setError('Error de conexión. Verifica que el servidor esté corriendo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ padding: isMobile ? '2rem 1rem' : '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: isMobile ? '1.75rem 1.25rem' : '2.5rem',
        width: '100%',
        maxWidth: '420px',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
      }}>
        <h1 style={{ color: theme.colors.primary, marginBottom: '0.5rem', textAlign: 'center', fontSize: '1.5rem' }}>
          Recuperar contraseña
        </h1>
        <p style={{ color: theme.colors.textMuted, textAlign: 'center', fontSize: '0.9rem', marginBottom: '2rem' }}>
          Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
        </p>

        {sent ? (
          <div>
            <div style={{
              backgroundColor: 'rgba(74,222,128,0.1)',
              border: `1px solid ${theme.colors.success}`,
              borderRadius: '8px',
              padding: '1rem',
              color: theme.colors.success,
              fontSize: '0.9rem',
              lineHeight: '1.6',
              marginBottom: '1.5rem',
              textAlign: 'center',
            }}>
              Si ese correo está registrado, recibirás un enlace en breve. Revisa también tu carpeta de spam.
            </div>
            <Link
              to="/login"
              style={{ display: 'block', textAlign: 'center', color: theme.colors.primary, fontSize: '0.9rem', textDecoration: 'none' }}
            >
              ← Volver al inicio de sesión
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={labelStyle}>Correo electrónico</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                style={inputStyle}
              />
            </div>

            {error && (
              <p style={{ color: theme.colors.error, textAlign: 'center', marginBottom: '1rem', fontSize: '0.9rem' }}>
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: loading ? theme.colors.border : theme.colors.primary,
                color: theme.colors.background,
                border: 'none',
                borderRadius: '7px',
                fontSize: '1rem',
                fontWeight: '700',
                cursor: loading ? 'not-allowed' : 'pointer',
                marginBottom: '1rem',
              }}
            >
              {loading ? 'Enviando...' : 'Enviar instrucciones'}
            </button>

            <p style={{ textAlign: 'center', margin: 0 }}>
              <Link to="/login" style={{ color: theme.colors.textMuted, fontSize: '0.9rem', textDecoration: 'none' }}>
                ← Volver al inicio de sesión
              </Link>
            </p>
          </form>
        )}
      </div>
    </main>
  );
}

export default ForgotPassword;
